<template>
  <el-dialog title="到货计划详情" :visible.sync="editInstallPlanFormVisible" class="dialog_block" width="600" height="500" :close-on-click-modal="false">
    <el-form
      ref="daohuoPlanForm"
      label-width="100px"
      class="demo-dynamic"
    >
      <el-form-item label="到货时间" prop="planDate">
        {{daohuoPlanForm.planDate}}
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="物流公司" prop="logisticsCompany">
            {{daohuoPlanForm.logisticsCompany}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物流单号" prop="logisticsNo">
            {{daohuoPlanForm.logisticsNo}}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="物流对接人" prop="logisticsUser">
            {{daohuoPlanForm.logisticsUser}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="phone">
            {{ daohuoPlanForm.phone }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="是否需要转运" prop="isTransport">
            {{ daohuoPlanForm.isTransport }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="到货方式" prop="arrivalMode">
            {{ daohuoPlanForm.arrivalMode }}
          </el-form-item>
        </el-col>
      </el-row>


    <div v-if="daohuoPlanForm.arrivalMode=='自提'" style="border: 1px solid rgba(25, 31, 37, 0.4);padding-right: 20px;">
      <div style="margin:10px 0 10px 24px;font-weight: 600;font-size: 16px">自提信息</div>
          <el-form-item label="地址">
            {{ daohuoPlanForm.arrivalDataInfo.addr }}
          </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="件数">
            {{ daohuoPlanForm.arrivalDataInfo.jianshu }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="方数">
            {{daohuoPlanForm.arrivalDataInfo.fangshu}}
          </el-form-item>
        </el-col>
      </el-row>


          <el-form-item label="到货内容">
            {{daohuoPlanForm.arrivalDataInfo.content}}
          </el-form-item>
    </div>
      <div v-if="daohuoPlanForm.arrivalMode=='货到现场'"  style="border: 1px solid rgba(25, 31, 37, 0.4);padding-right: 20px;">

        <div v-for="(item,index) in daohuoPlanForm.carIformationList" :key="index" style="border-bottom: 1px solid rgba(25, 31, 37, 0.4)">
          <el-row>
            <el-col :span="24" style="padding:10px 0 10px 24px;font-weight: 600;font-size: 16px">到货车次及车型{{index+1}}</el-col>

          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="车辆类型">
                {{item.carModel}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车牌号">
                {{item.carPlateNumber}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="件数">
                {{item.number}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="方数">
                {{item.SquareNumber}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="司机姓名">
               {{item.driverName}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="司机电话">
                {{item.driverPhone}}
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="到货内容">
            {{item.content}}
          </el-form-item>
        </div>

      </div>
    </el-form>
    <hr>

  </el-dialog>
</template>

<script>
import { objKeySort } from "@/util/ajaxsign";
export default {
  name: "editBasePlan",
  data() {
    return {
      editInstallPlanFormVisible: false,
      dialogTitle: "添加到货计划",
      typeId:0,
      daohuoPlanForm: {
        id: "",
        planDate:"",
        logisticsNo: "",
        logisticsCompany:"",
        logisticsUser:"",
        phone:"",
        isTransport:"",
        arrivalMode:"",
        arrivalDataInfo:{},
        carIformationList:[],
        fangshuSum:0,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= new Date().getTime() - 86400000;
        }
      },
      isTransportOption:['是，需要现场地库倒货','是，需要现场地面倒货','否，不需要倒货'],
      arrivalModeOption:['自提','货到现场'],
      carList:['17.5m平板','17.5m厢货','13m高栏','13m厢货','9.6m高栏','9.6m厢货','7.6m高栏','7.6m厢货','6.8m高栏','6.8m厢货','4.2m高栏','4.2m厢货','金杯/全顺'],
      rules: {
        planDate: [{ required: true, message: "请填写到货时间", trigger: "blur" }],
        content: [{ required: true, message: "请填写到货内容", trigger: "blur" }]
      }
    };
  },

  created() {

  },
  filters: {

  },
  methods: {

    //选择开工时间
    changeTableDate(e) {
      let that = this
      console.log("勘察日期：",e);
      that.daohuoPlanForm.planDate = e
    },


    setData(data) {
      this.editInstallPlanFormVisible = true;
      this.cleanForm();
      if (data) {
        this.daohuoPlanForm = data;
      }
    },


    delCarIformation(index){
      this.daohuoPlanForm.carIformationList.splice(index,1);
    },

    arrivalModeChange(e){
      if(e=='货到现场'){
        this.daohuoPlanForm.carIformationList=[{
          carModel:'',
          carPlateNumber:'',
          number:'',
          SquareNumber:'',
          driverName:'',
          driverPhone:'',
          content:''
        }]
      }

    },



    close() {
      this.editInstallPlanFormVisible = false;
      this.cleanForm();
    },
    cleanForm() {

        if(this.$refs.daohuoPlanForm){
          this.$refs.daohuoPlanForm.clearValidate();

          this.daohuoPlanForm = {
            id: "",
            index:-1,
            planDate:"",
            logisticsNo: "",
            logisticsCompany:"",
            logisticsUser:"",
            phone:"",
            isTransport:"",
            arrivalMode:"",
            arrivalDataInfo:{},
            carIformationList:[],
            fangshuSum:0,
          };
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .mb_7{
    margin-bottom: 7px;
  }
  .pro_el-input{
    width: 100% !important;
  }
  .width_80{
    width: 80px;
    margin-top: 0;
  }
  .el-button{
   padding: 1px 16px;
  }
  .el-upload--picture-card{
    width: 125px;
    height: 125px;
    border-radius:3px;
    border:1px solid rgba(237,239,242,1);
    img{
      width: 100%;
      height: 100%;
      object-fit: contain !important;
    }
  }
  .el-upload-list__item{
    img{
      width: 100%;
      height: 100%;
      object-fit: contain !important;
    }
  }

  .delBtn {
    color: #FF0000;
    border-radius: 4px;
    border: 1px solid #FF0000;
  }

  .foot_span{
    text-align: right;
    margin-right: 56px;
  }
  hr {
    bottom: 72px;
    border-color: rgba(245, 247, 250, 0.2);
    margin-bottom: 15px;
  }
  .el-dialog__body{
    padding: 0 !important;
  }
  .el-upload-list__item:first-child{
    margin-top: 0 !important;
  }
  .el-form-item{
    margin-bottom: 0px!important;
  }
</style>
